<script>
import BaseInfo from './BaseInfo'
export default {
  name: 'ExtendConfig',
  extends: BaseInfo,
  data () {
    return {
      formListKey: 'formListExtend'
    }
  }
}
</script>
